import { IEvaluationContext } from "../IEvaluationContext";
import { IKCExpressionRuntime, KCExpressionRuntime } from "../KCExpressionRuntime";

import { ValidationFunctionResult, ValidationFunctionResults, ValidationSeverity } from "./ValidationFunction";
import { isPromise } from "./IsPromise";

type EvaluatorFunc = (kcExpression: IKCExpressionRuntime) => boolean | undefined | Promise<boolean | undefined>;
type MessageEvaluatorFunc = (kcExpression: IKCExpressionRuntime) => string | undefined;

export class KCCondition {
    public static execute(
        context: IEvaluationContext,
        kcConditionEvaluator: EvaluatorFunc,
        message: MessageEvaluatorFunc,
        severity: ValidationSeverity
    ): ValidationFunctionResult | Promise<ValidationFunctionResult> {
        const expressionRuntime = new KCExpressionRuntime(context);
        const evaluatorResult = kcConditionEvaluator(expressionRuntime);
        if (isPromise(evaluatorResult)) {
            return (async (): Promise<ValidationFunctionResult> => {
                const isValid = (await evaluatorResult) ?? false;
                if (isValid) {
                    return ValidationFunctionResults.Valid();
                } else {
                    return ValidationFunctionResults.Invalid(message(expressionRuntime) ?? "", severity);
                }
            })();
        }
        const isValid = evaluatorResult ?? false;
        if (isValid) {
            return ValidationFunctionResults.Valid();
        } else {
            return ValidationFunctionResults.Invalid(message(expressionRuntime) ?? "", severity);
        }
    }
}
